// extracted by mini-css-extract-plugin
export default {"BrandName":"styles_BrandName__7uN3J","inputContainer":"styles_inputContainer__+IGMG","savedName":"styles_savedName__CXOqO","editButton":"styles_editButton__sHbSe"};